<template>
  <div class="reg-temp-content-area main-content-height p-5">

      <!-- <a href="#" @click.prevent="back()"  class="mb-3 inline-block"> <i class="fas fa-long-arrow-alt-left"></i> Back</a> -->
      <h2 class="mb-2" v-if="$route.query.heading">{{ $route.query.heading }} <span class="font-light">Customers</span></h2>
      <div class="row">
        <div class="col-sm-12 col-md-12  mb-2">
          <div class="row justify-content-between">
            <div class="col-sm-12 col-md-12 col-lg-12 mb-2">
                <input class="search-input top-search-input" v-model="s" placeholder="Search by Email / Company"/>
            </div>

             <div class="col-sm-12 col-md-12 col-lg-12">
              <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12 text-center"  v-if="loading">
              <loading/>
            </div>

            <div class="text-center col-sm-12 col-md-12" v-if="!loading && (loadCount == 1) && (customers.length < 1)">
             <p>No customer found.</p>
            </div>

            <div v-if="!loading" class="col-sm-12 col-md-6 col-lg-6 col-xl-4" v-bind:key="'reseller_'+ index" v-for="(customer, index) in customers">
              <customer-item :editcallback="editCallBack" :s="s" :currentpage="currentPage" :deletecallback="deleteCallBack" :user="customer" />
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
              <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>
          </div>
        </div>
      </div>
    
      <!-- <vue-good-table
        v-else
        :columns="columns"
        :search-options="{
          enabled: false
        }"
      :rows="rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'" class="table-action-wrapper">
            <router-link :to="{ name: 'SuperadminCustomersEdit',  params: { id: props.row.id }, query: {redirect: 'SuperadminCustomers', page: currentPage, s: s} }" class="edit-action"><i class="fas fa-pencil-alt"></i></router-link>
            <a href="#" @click.prevent="deleteThis(props.row)" class="delete-action"><i aria-hidden="true" class="fa fa-trash"></i></a>
          </span>
          <span v-else-if="props.column.field == 'regproduct'">
            <div v-if="props.row.registered_products.length > 0">
              <span v-bind:key="regp.id" v-for="regp in props.row.registered_products">{{ regp.serial_number }} / {{ regp.coc_number }}<br/></span>
            </div>
            <span v-else>0</span>
          </span>
           <template v-else-if="props.column.field == 'fname'">
             <span v-html="props.row.fname"></span>
          </template>
        </template>
      </vue-good-table>  
      <pagination :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination> -->
   
  </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from "vuex";
import Loading from '../../components/Loading.vue';

export default {
  name: 'superadminCustomerList',
  components: {
    Pagination

  },
  data(){
    return {
      loadCount: 0,
      loading: false,
      s: '',
      view: {
        show: false,
        obj: {},
      },
      pdfdata: '',
      loading: false,
      currentPage: 1,
      pageNavs: [],
      customers: [],
    };
  },
  computed: {

  },

  watch:{
 
    's'() {
      if(this.loadCount > 0){
        this.currentPage = 1;
        this.fetchDistributorCustomers();
      }
    },
  
  },
  mounted() {
   
    //this.s = this.$route.query.s ? this.$route.query.s : '';
    this.fetchDistributorCustomers();
  },
  methods: {
    /**
     * Fetch reg products
     */
    fetchDistributorCustomers: _.debounce(function(){
    // fetchDistributorCustomers() {
      // whjen page load for first time then 
      if(this.loadCount == 0){
        if( this.$route.query.currentpage ){
          this.currentPage = parseInt(this.$route.query.currentpage);
        }
        if( this.$route.query.s ){
          this.s = this.$route.query.s;
        }
      }

      this.loading = true;
      const url = `${Env.baseUrl}/superadmin/distributor/${this.$route.params.distributorid}/showcustomers?page=${this.currentPage}&s=${this.s}`;
      AuthApis.postApi(url, {
      }).then(res => {
        this.customers = res.data.payload;
         this.loadCount = 1;
        this.pageNavs= res.data.nav;
        this.loading = false;
      }).catch(err => {
        console.log(err)
        this.loading = true;
      })
    }, 300),

    /**
     * Fetch page data
     */
    fetchPage(pageNo){
      this.currentPage = pageNo;
      this.fetchDistributorCustomers();
    },

    /**
     * Delete record
     */
    deleteThis(user) {
      this.$confirm(
        {
          title: `DELETE?`,
          message: 'Are you sure you want to delete ' + user.email ,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              const url = `${Env.baseUrl}/superadmin/users/delete/${user.id}`;
              AuthApis.deleteApi(url).then(async (res) => {
                this.fetchDistributorCustomers();
                this.$toasted.global.success({
                  message: 'Successfully deleted.'
                })
              }).catch(err => {
                this.$toasted.global.error({
                  message: err.response.data.message ? err.response.data.message : 'Failed, please try again later.'
                })
              })
            }
          }
        }
      )
    },

    back() {
      this.$router.push({ name: 'SuperadminDistributors', query: this.$route.query});
    },

    ...mapActions({
   
    }),
  
  }
};
</script>